module.exports = __webpack_public_path__ + "static/img/banner110.6cb11bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icon/banner110.jpg
// module id = HP6I
// module chunks = 0